<div class="happy-helper-usps outer_seo_page_component_container">
  <div class="inner_seo_page_component_container">
    <div class="usps-content">
      <div class="usps-left">
        <div class="usps-header">
          <img
            src="/assets/svg/happy_logo.png"
            alt="Happy Helper Logo"
            class="happy-logo"
          />
        </div>

        <div class="usps-footer">
          <p>
            Få 100 kr til fast rengøring med koden:
            <strong>{{ happyHelperCode }}</strong>
          </p>
        </div>
        <div class="usps-list">
          <div class="usp-item">
            <mat-icon>savings</mat-icon>
            <div class="usp-text">
              <h3>Billig rengøring</h3>
              <p>Få professionel rengøring til konkurrencedygtige priser</p>
            </div>
          </div>

          <div class="usp-item">
            <mat-icon>verified</mat-icon>
            <div class="usp-text">
              <h3>Over 30.000 rengøringer</h3>
              <p>Vi har renset mere end 30.000 hjem og kontorer</p>
            </div>
          </div>

          <div class="usp-item">
            <mat-icon>security</mat-icon>
            <div class="usp-text">
              <h3>Gratis forsikring</h3>
              <p>Alle vores rengøringer er dækket af forsikring</p>
            </div>
          </div>
        </div>
        <div class="usps-footer">
          <button
            class="handyhand_button blue_button"
            (click)="goToUserHappyHelper()"
          >
            Book nu
          </button>
        </div>
      </div>

      <div class="usps-right">
        <img
          [ngSrc]="happyHelperWorker"
          fill
          priority
          alt="Happy Helper Worker"
          class="worker-image"
        />
      </div>
    </div>
  </div>
</div>
